//전체학생정보 → 직원관리 메뉴 이동 (한 곳에서만 관리 — 3단계에서 목적지 알약을 newTodo/leaveTodo 로 바꾸면 됨)
//HashRouter(history 4.10) 는 push 의 state 를 버리므로 쿼리스트링이 실제 전달 수단. state 는 덤으로 실어둠

export type StaffPill = "roster" | "newTodo" | "leaveTodo" | "variables";

export interface StaffManageState {
    pill: StaffPill;
    search: string;
}

export const STAFF_MANAGE_PATH = "/dashboard/staffmanage";

export const goToStaffManage = (history: any, state: StaffManageState) => {
    const params = new URLSearchParams();
    params.set("pill", state.pill);
    if (state.search) {
        params.set("search", state.search);
    }
    history.push({ pathname: STAFF_MANAGE_PATH, search: `?${params.toString()}`, state: { staffManage: state } });
};

//전체학생정보 "신규TODO" / "퇴원TODO" (직원) 의 목적지 — 3단계: 신규직원 TODO / 퇴사직원 TODO
export const goToStaffNewTodo = (history: any, search: string) => goToStaffManage(history, { pill: "newTodo", search });
export const goToStaffLeaveTodo = (history: any, search: string) => goToStaffManage(history, { pill: "leaveTodo", search });

const PILLS: StaffPill[] = ["roster", "newTodo", "leaveTodo", "variables"];

export const readStaffManageState = (location: any): StaffManageState | null => {
    if (location && location.state && location.state.staffManage) {
        return location.state.staffManage;
    }
    const params = new URLSearchParams(location && location.search ? location.search : "");
    const pill = params.get("pill");
    if (!pill || !PILLS.includes(pill as StaffPill)) {
        return null;
    }
    return { pill: pill as StaffPill, search: params.get("search") || "" };
};
